export const schedulerSx = {
  width: '100%',
  flex: 1,
  height: '100vh',
  maxHeight: '100vh',
  overflowY: 'auto',
  backgroundColor: '#FFFFFF',
  '& .mbsc-eventcalendar': {
    backgroundColor: '#FFFFFF',
  },
  '& .mbsc-calendar-header, & .mbsc-eventcalendar-header, & .mbsc-calendar-controls':
    {
      backgroundColor: '#FFFFFF !important',
    },
  '& .mbsc-timeline': {
    borderColor: '#E2E8F0',
    backgroundColor: '#FFFFFF',
  },
  '& .mbsc-timeline-resource-col': {
    width: '190px !important',
    borderRight: '1px solid #E2E8F0 !important',
    backgroundColor: '#FFFFFF',
  },
  '& .mbsc-timeline-resource': {
    borderBottom: '1px solid #E8EEF5 !important',
    backgroundColor: '#FFFFFF',
  },
  '& .mbsc-timeline-resource-cell': {
    height: '100% !important',
    padding: '10px !important',
    display: 'flex !important',
    alignItems: 'center !important',
    boxSizing: 'border-box',
  },
  '& .mbsc-timeline-resource-cell > *': {
    width: '100%',
  },
  '& .mbsc-timeline-header-column': {
    width: '54px !important',
    borderColor: '#E8EEF5 !important',
    backgroundColor: '#FFFFFF !important',
  },
  '& .mbsc-timeline-column': {
    width: '54px !important',
    borderColor: '#E8EEF5 !important',
    backgroundColor: '#FFFFFF',
  },
  '& .mbsc-timeline-header': {
    borderColor: '#E2E8F0 !important',
    backgroundColor: '#FFFFFF !important',
  },
  '& .mbsc-timeline-header-bg, & .mbsc-timeline-header-row, & .mbsc-timeline-header-date':
    {
      backgroundColor: '#FFFFFF !important',
    },
  '& .mbsc-timeline-header-column-empty, & .mbsc-timeline-header-date-empty': {
    backgroundColor: '#FFFFFF !important',
    borderColor: '#FFFFFF !important',
  },
  '& .mbsc-timeline-header-date, & .mbsc-timeline-header-column': {
    minHeight: '34px !important',
  },
  '& .mbsc-timeline-header-date-text, & .mbsc-timeline-time': {
    color: '#64748B !important',
    fontSize: '13px !important',
    fontWeight: '600 !important',
  },
  '& .mbsc-timeline-header-active, & .mbsc-timeline-header-active.mbsc-timeline-header-date-text, & .mbsc-timeline-header-active .mbsc-timeline-header-date-text, & .mbsc-timeline-header-date.mbsc-timeline-header-active .mbsc-timeline-header-date-text, & .mbsc-timeline-header-date.mbsc-selected .mbsc-timeline-header-date-text, & .mbsc-timeline-header-date.mbsc-today .mbsc-timeline-header-date-text, & .mbsc-timeline-header-date.mbsc-current .mbsc-timeline-header-date-text, & .mbsc-timeline-header-date-text.mbsc-selected, & .mbsc-timeline-header-date-text.mbsc-today, & .mbsc-timeline-header-date-text.mbsc-current':
    {
      color: '#FFFFFF !important',
      display: 'inline-flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      verticalAlign: 'middle !important',
    },
  '& .mbsc-timeline-row, & .mbsc-timeline-day': {
    borderColor: '#E8EEF5 !important',
  },
  '& .mbsc-schedule-event, & .mbsc-timeline-event': {
    padding: '3px 4px !important',
  },
  '& .mbsc-schedule-event-inner, & .mbsc-timeline-event-inner': {
    background: 'transparent !important',
    border: '0 !important',
    boxShadow: 'none !important',
    padding: '0 !important',
  },
  '& .mbsc-timeline-event-background': {
    background: 'transparent !important',
    border: '0 !important',
  },
  '& .mbsc-schedule-invalid, & .mbsc-timeline-invalid, & .timeoff': {
    opacity: '1 !important',
    color: '#8A9BB1 !important',
    backgroundColor: '#F8FAFC !important',
    backgroundImage:
      'repeating-linear-gradient(45deg, rgba(148, 163, 184, 0.12) 0px, rgba(148, 163, 184, 0.12) 8px, transparent 8px, transparent 16px) !important',
    border: '0 !important',
  },
  '& .mbsc-schedule-invalid-text, & .mbsc-timeline-invalid-text': {
    color: '#8A9BB1 !important',
    fontSize: '13px !important',
    fontWeight: '600 !important',
  },
  '& .mbsc-timeline-header-date-text': {
    marginLeft: 'auto ',
    textAlign: 'right ',
    paddingRight: 1,
    marginTop: 0.2,
    marginBottom: 0.2,
  },
  '& .mbsc-timeline-header-date': {
    marginLeft: 'auto ',
    textAlign: 'right ',
    paddingRight: 1,
    marginTop: 0.2,
    marginBottom: 0.2,
  },
};
